// @flow

// polyfills up top
import './polyfills'

// import sass for webpack build process
import '../scss/styles.scss'

import 'what-input'

// sets a listener for any #anchor link to smooth scroll
// see utils/scroll-to.js for .go-to custom scrolling that accounts for header
import 'smoothscroll'

// lazySizes still used even though not explicitly called anywhere
// TODO: chrome has lazyloading build in @see https://scotch.io/bar-talk/native-lazy-loading-launched-on-chrome-76
// eslint-disable-next-line
import 'lazysizes'
import Mailcheck from 'mailcheck'

import Vue from 'vue'

// sentry error tracking after loading vue
import errorTrackerInit from './error-tracker'
errorTrackerInit(Vue)

import VueResource from 'vue-resource'
import VeeValidate from 'vee-validate'
import validationRules from 'app/utils/validation-rules'
import { Carousel, Slide } from 'vue-carousel'

import { fbAnnouncement } from 'app/common/announcement'

// vue pages mounted by JSX (old way to mound by id)
// TODO: eventually would like to get these mounted via id="vue" and import components (see Vue.component section at the bottom)
import { CommentsView } from 'app/views/comments'
import { DiscussionFooterView, DiscussionsControlsView } from 'app/views/discussion'
import { DiscussionFormView } from 'app/views/forms'
import { NotificationsView } from 'app/views/notifications'
import calendarInit from 'app/views/calendar'
import scrollToInit from 'app/utils/scroll-to'
import singleClickSubmit from 'app/utils/blade-submit'

/* TODO: we probably do not need this anymore, audit usage, then remove */
/* eslint-disable-next-line */
import Modernizr from 'app/.modernizrrc'

// dynamic SPA routing
import createSpaRoutes from './router'
import store from 'app/store'
import RouterView from './components/router/router-view.vue'

window.store = store
window.Vue = Vue
window.Mailcheck = Mailcheck

// add vee-validator for form validation
Vue.use(VueResource)
import { Validator } from 'vee-validate'
validationRules(Validator)
Vue.use(VeeValidate, { events: 'blur' })

// add csrf token to vue requests
Vue.http.interceptors.push((request, next) => {
  request.headers.set('X-CSRF-TOKEN', Laravel.csrfToken)
  next()
})

/**
 * Header
 */
import { Header } from 'app/common/header-init'
const header = new Header()
header.init()

/**
 * Initialize (vue) Views, these are older and use jsx,
 * would like to convert to these to component registered pages
 * and load via id="vue"
 */
if (document.getElementById('comments') !== null) {
  CommentsView.$mount('#comments')
}

if (document.getElementById('discussionFooter') !== null) {
  DiscussionFooterView.$mount('#discussionFooter')
}

if (document.getElementById('listing-controls') !== null) {
  DiscussionsControlsView.$mount('#listing-controls')
}

if (document.getElementById('discussion-form') !== null) {
  DiscussionFormView.$mount('#discussion-form')
}

if (document.getElementById('notification-listing') !== null) {
  NotificationsView.$mount('#notification-listing')
}

/**
 * Initialize non-vue items
 */
document.addEventListener('DOMContentLoaded', () => {
  // Announcement Bar
  if (document.getElementById('announcement') !== null) {
    fbAnnouncement()
  }

  // support for smooth scrolling to .go-to links
  scrollToInit()

  // disable double submits from blade forms
  singleClickSubmit()

  // load functionality for calendar.blade.php, it isn't vue :(
  calendarInit()
})

/**
 * Components for use in Laravel Blade template rendering
 */
import ModalConfirm from 'app/components/modals/modal-confirm.vue'
import CalendarNotes from 'app/components/calendar/calendar-notes.vue'
import SubmitButton from 'app/components/buttons/submit-button.vue'
import Callout from 'app/components/notifications/callout.vue'
import DashboardToggleBar from 'app/components/analytics/workout-detail/dashboard-toggle-bar.vue'

// carousel
import HomeCarousel from 'app/components/carousels/home-carousel.vue'
import AboutCarousel from 'app/components/carousels/about-carousel.vue'

// code split components
import subscriptionCodeSplit from 'app/views/subscriptions'
import accountCodeSplit from 'app/views/users'
import searchCodeSplit from 'app/views/search'
import miscCodeSplit from 'app/views/misc-ctas'

// TODO: move these into appropriate chunks
Vue.component('modal-confirm', ModalConfirm)
Vue.component('calendar-notes', CalendarNotes)
Vue.component('submit-button', SubmitButton)
Vue.component('callout', Callout)
Vue.component('dashboard-toggle-bar', DashboardToggleBar)

// home, about
Vue.component('home-carousel', HomeCarousel)
Vue.component('about-carousel', AboutCarousel)

// only used on my dashboard
// TODO: refactor so dashboard can be it's own component
Vue.component('carousel', Carousel)
Vue.component('slide', Slide)

/**
 * Code split subscription and organization views
 */
subscriptionCodeSplit()

// lazy load user components
accountCodeSplit()

// lazy load search components
searchCodeSplit()

// catch all components, mostly buttons / cta / fixed bars
miscCodeSplit()

// SPA routes (mounted on id="app")
const router = createSpaRoutes({ store })
Vue.router = router

const SPA = new Vue({
  store,
  router,
  ...RouterView,
})
if (document.getElementById('app') !== null) {
  SPA.$mount('#app')
}

// non SPA routes (new - 2019/08)
// use id="vue" or class="vue" in the blade template and this will pick up on any components
// registered above and ideally avoid "vue not loaded"
if (document.querySelector('#vue')) {
  new Vue({
    store,
    el: '#vue',
  })
}
const vueClasses = document.querySelectorAll('.vue')
if (vueClasses.length) {
  for (let i = 0; i < vueClasses.length; ++i) {
    new Vue({
      store,
      el: vueClasses[i],
    })
  }
}
// end non-SPA routes

//Note: readmore not currently used, but needed for call below and polyfill
//const readMoreButtons = document.querySelectorAll('[data-readmore]')

// NOTE: this "of" call is needed to cause bablerc to add in symbol polyfills that are used in
// header-init.js:     this.dropDownButtons = [...document.querySelectorAll('.dropdown-button')]
// this "of" call is what causes it, but that spread call doesn't
// for (const button of readMoreButtons) {
//   button.addEventListener('click', function(e: any) {
//     this.parentNode.classList.toggle('active')
//   })
// }
